import React from "react";
import { PanelGroup, Panel } from "./bootstrap-panel";

const Accordion = ({
  id,
  titleContent,
  children,
  eventKey = "1",
  customClass = "",
  bodyClass = "",
  panelHeadingClass = "",
  defaultExpanded = false,
  defaultActiveKey,
  onClick,
}) => {
  const resolvedDefaultActiveKey =
    defaultActiveKey !== undefined ? defaultActiveKey : defaultExpanded ? eventKey : undefined;

  return (
    <PanelGroup
      accordion
      id={id}
      className={customClass}
      defaultActiveKey={resolvedDefaultActiveKey}
    >
      <Panel eventKey={eventKey}>
        <Panel.Heading className={panelHeadingClass}>
          <Panel.Title toggle onClick={onClick}>
            {titleContent}
          </Panel.Title>
        </Panel.Heading>
        <Panel.Body collapsible className={bodyClass}>
          {children}
        </Panel.Body>
      </Panel>
    </PanelGroup>
  );
};

export default Accordion;
